import { AbstractStore } from "@yuigoto/abst";

/**
 * core/glambox/GlamboxSessionStore
 * ----------------------------------------------------------------------
 * Fornece uma interface para armazenar e gerenciar dados em `sessionStorage`,
 * com suporte à namespacing de valores com prefixo.
 * 
 * @since     0.0.1
 */
export class GlamboxSessionStore extends AbstractStore {
  // Propriedades
  // --------------------------------------------------------------------

  /**
   * Prefixo usado para namespacing.
   * 
   * @type {String}
   */
  _prefix = null;

  // Lifecycle
  // --------------------------------------------------------------------

  /**
   * Construtor.
   * 
   * @param {String} prefix 
   *     Prefixo opcional, para uso de namespacing na store
   */
  constructor (prefix) {
    super();

    if (typeof prefix === "string" && prefix.trim() !== "") {
      this.prefix = prefix.trim();
    }
  }

  // Getters + Setters
  // --------------------------------------------------------------------

  /**
   * Prefixo usado para namespacing.
   * 
   * @type {String}
   */
  get prefix () {
    return this._prefix;
  }

  set prefix (value) {
    this._prefix = value;
  }

  // Public Methods
  // --------------------------------------------------------------------

  /**
   * Retorna um item da store.
   * 
   * @param {String} key 
   *     Nome do item a ser retornado
   */
  get (key) {

    if (this.prefix !== null && this.prefix !== undefined) {
      key = this.prefix + "." + key.trim();
    }

    let item = sessionStorage.getItem(key);

    if (null === item) return null;

    try {
      return JSON.parse(item);
    } catch (e) {
      //console.error(`Item retornado não é um JSON, retornando valor cru.`);
      //console.error(e);
    }
    return item;
  }

  /**
   * Retorna um hashmap contendo todos os itens da store.
   * 
   * @returns {Object}
   */
  getAll () {
    let items = {};

    for (let n = 0; n < sessionStorage.length; n++) {
      let key = sessionStorage.key(n),
          item;
      
      if (this.prefix !== null && this.prefix !== undefined) {
        let regex = new RegExp(`^${this.prefix}`);
        if (key.match(regex) === null) continue;
      }

      item = sessionStorage.getItem(key);
      if (item !== null) items[key] = item;
    }

    return items;
  }

  /**
   * Define um único item na store.
   * 
   * @param {String} key 
   *     Nome da chave a ser definida 
   * @param {*} value 
   *     Valor a ser armazenado 
   */
  set (key, value) {
    if (this.prefix !== null && this.prefix !== undefined) {
      key = this.prefix + "." + key.trim();
    }
    
    if (typeof value === "object" || Array.isArray(value)) {
      sessionStorage.setItem(key, JSON.stringify(value));
    } else {
      sessionStorage.setItem(key, value);
    }
  }

  /**
   * Remove um único item da store. 
   * 
   * @param {String} key 
   *     Chave a ser excluída da store
   */
  remove (key) {
    if (this.prefix !== null && this.prefix !== undefined) {
      key = this.prefix + "." + key.trim();
    }

    sessionStorage.removeItem(key);
  }

  /**
   * Limpa todos os itens da Store.
   */
  clear () {
    if (this.prefix !== null && this.prefix !== undefined) {
      let regex = new RegExp(`^${this.prefix}`);

      Object
        .keys(sessionStorage)
        .forEach(key => {
          if (regex.test(key)) sessionStorage.removeItem(key);
        });
    } else {
      sessionStorage.clear();
    }
  }
}
